import React from 'react'

import { AdminHeader, Layout } from 'components'
import { ChartSourcesContainer } from 'modules/ChartSources/containers'

const ChartSourcesPage = () => (
  <Layout>
    <AdminHeader />
    <ChartSourcesContainer />
  </Layout>
)

export default ChartSourcesPage
